/**
 * Whether the current user may edit/delete a given SOP, mirroring the
 * backend rule in permissions_service.can_edit_sop():
 *  - national_admin: always.
 *  - site_admin / validator (can_edit_all=true): only if the SOP's site is
 *    within their assigned site(s).
 *  - creator: only for SOPs they personally created.
 *  - viewer / none: never.
 */
export function canManageSop(user, sop) {
  const perms = user?.permissions;
  if (!perms || !sop) return false;
  if (perms.role === "national_admin") return true;
  if (perms.can_edit_all) return perms.sites?.includes(sop.site);
  if (perms.role === "creator") return sop.created_by_email === user.email;
  return false;
}

/** Libellé + style Tailwind du badge de rôle affiché dans l'en-tête. */
export const ROLE_LABELS = {
  national_admin: { label: "Admin National", className: "bg-primary text-primary-foreground border-transparent" },
  site_admin: { label: "Admin Site", className: "bg-accent text-accent-foreground border-transparent" },
  validator: { label: "Valideur SOP", className: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-900/40 dark:text-sky-300 dark:border-sky-800" },
  creator: { label: "Créateur SOP", className: "bg-teal-100 text-teal-800 border-teal-200 dark:bg-teal-900/40 dark:text-teal-300 dark:border-teal-800" },
  viewer: { label: "Utilisateur SOP", className: "bg-muted text-muted-foreground border-border" },
};

export function getRoleBadge(user) {
  const role = user?.permissions?.role;
  return ROLE_LABELS[role] || null;
}

/** National & site admins can manage users/roles from the "Gestion des utilisateurs" screen. */
export function canManageUsers(user) {
  const role = user?.permissions?.role;
  return role === "national_admin" || role === "site_admin";
}
